var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFieldCrosses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 79.374998 79.375",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    style: {
      strokeWidth: 1.00012499,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect12",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012499,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M 0,0 V 0.2191081 1.2236979 H 0.21910808 V 0.2191081 H 1.2242147 V 0 H 0.21910808 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012499,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m 79.375,0 h -0.219108 -1.004589 v 0.219108 h 1.004589 V 1.224215 H 79.375 V 0.219108 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012499,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "m 79.375,79.375 v -0.219108 -1.004589 h -0.219108 v 1.004589 H 78.150785 V 79.375 h 1.005107 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012499,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    d: "M 0,79.375 H 0.219108 1.223697 V 79.155892 H 0.219108 V 78.150785 H 0 v 1.005107 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 0,13.156131 v 0.219108 0.219108 h 0.21910807 v -0.219108 -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 0,26.312261 v 0.219108 0.219108 h 0.21910807 v -0.219108 -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 0,39.468392 V 39.6875 39.906608 H 0.21910807 V 39.6875 39.468392 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 0,65.780653 v 0.219108 0.219108 h 0.21910807 v -0.219108 -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 0,52.624523 v 0.219108 0.219108 h 0.21910807 v -0.219108 -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 0.32866213,0 h -0.2191081 -0.219108 v 0.21910806 h 0.219108 0.2191081 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 0.3286621,79.155892 H 0.109554 -0.109554 V 79.375 h 0.219108 0.2191081 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g17",
    transform: "translate(79.155891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 0,13.156131 v 0.219108 0.219108 h 0.21910807 v -0.219108 -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 0,26.312261 v 0.219108 0.219108 h 0.21910807 v -0.219108 -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 0,39.468392 V 39.6875 39.906608 H 0.21910807 V 39.6875 39.468392 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 0,65.780653 v 0.219108 0.219108 h 0.21910807 v -0.219108 -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 0,52.624523 v 0.219108 0.219108 h 0.21910807 v -0.219108 -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 0.32866213,0 h -0.2191081 -0.219108 v 0.21910806 h 0.219108 0.2191081 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 0.3286621,79.155892 H 0.109554 -0.109554 V 79.375 h 0.219108 0.2191081 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g61",
    transform: "translate(-46.631261,-0.219108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path55",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.64132,13.375928 v 0.218074 10e-4 0.218074 h 0.219108 0.219108 v -0.218074 -10e-4 -0.218074 h -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,26.531197 v 0.219108 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219108 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,39.687499 v 0.219109 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219109 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,65.999588 v 0.219108 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219108 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,52.843802 v 0.219108 0.219108 h 0.218074 0.001 0.218074 V 53.06291 52.843802 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 60.080218,79.375 H 59.86111 59.642002 v 0.219108 h 0.219108 0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 60.080218,0.219108 H 59.86111 59.642002 v 0.21910806 h 0.219108 0.219108 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "translate(-33.402095,-0.219108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.64132,13.375928 v 0.218074 10e-4 0.218074 h 0.219108 0.219108 v -0.218074 -10e-4 -0.218074 h -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,26.531197 v 0.219108 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219108 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,39.687499 v 0.219109 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219109 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,65.999588 v 0.219108 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219108 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,52.843802 v 0.219108 0.219108 h 0.218074 0.001 0.218074 V 53.06291 52.843802 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 60.080218,79.375 H 59.86111 59.642002 v 0.219108 h 0.219108 0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 60.080218,0.219108 H 59.86111 59.642002 v 0.21910806 h 0.219108 0.219108 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g40",
    transform: "translate(-6.943762,-0.219108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.64132,13.375928 v 0.218074 10e-4 0.218074 h 0.219108 0.219108 v -0.218074 -10e-4 -0.218074 h -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,26.531197 v 0.219108 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219108 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,39.687499 v 0.219109 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219109 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,65.999588 v 0.219108 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219108 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,52.843802 v 0.219108 0.219108 h 0.218074 0.001 0.218074 V 53.06291 52.843802 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 60.080218,79.375 H 59.86111 59.642002 v 0.219108 h 0.219108 0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 60.080218,0.219108 H 59.86111 59.642002 v 0.21910806 h 0.219108 0.219108 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g47",
    transform: "translate(-20.172929,-0.219108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path41",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.64132,13.375928 v 0.218074 10e-4 0.218074 h 0.219108 0.219108 v -0.218074 -10e-4 -0.218074 h -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,26.531197 v 0.219108 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219108 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,39.687499 v 0.219109 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219109 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,65.999588 v 0.219108 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219108 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,52.843802 v 0.219108 0.219108 h 0.218074 0.001 0.218074 V 53.06291 52.843802 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 60.080218,79.375 H 59.86111 59.642002 v 0.219108 h 0.219108 0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 60.080218,0.219108 H 59.86111 59.642002 v 0.21910806 h 0.219108 0.219108 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g33",
    transform: "translate(6.2854045,-0.219108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.64132,13.375928 v 0.218074 10e-4 0.218074 h 0.219108 0.219108 v -0.218074 -10e-4 -0.218074 h -0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,26.531197 v 0.219108 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219108 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,39.687499 v 0.219109 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219109 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,65.999588 v 0.219108 0.219108 h 0.218074 0.001 0.218074 v -0.219108 -0.219108 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "m 59.641837,52.843802 v 0.219108 0.219108 h 0.218074 0.001 0.218074 V 53.06291 52.843802 h -0.218074 -0.001 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 60.080218,79.375 H 59.86111 59.642002 v 0.219108 h 0.219108 0.219108 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    style: {
      fill: "#808080",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.00012,
      strokeLinecap: "square",
      strokeMiterlimit: 0,
      strokeDasharray: "none"
    },
    d: "M 60.080218,0.219108 H 59.86111 59.642002 v 0.21910806 h 0.219108 0.219108 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldCrosses);
export default __webpack_public_path__ + "static/media/field_crosses.1852da228d3bc49d74e7819a6d056743.svg";
export { ForwardRef as ReactComponent };